import { NotFoundCallError } from "./not-found-call-error";

export class GroupNotFoundCallError extends NotFoundCallError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
  }
}
